import * as S from './styles';

function PaleScreen() {
  return <S.Container />;
}

export default PaleScreen;
